import { render } from "./VideoListElement.vue?vue&type=template&id=de9bf6ae"
import script from "./VideoListElement.vue?vue&type=script&lang=js"
export * from "./VideoListElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__